import { render, staticRenderFns } from "./text-image-cta.vue?vue&type=template&id=24c44842"
import script from "./text-image-cta.vue?vue&type=script&lang=js"
export * from "./text-image-cta.vue?vue&type=script&lang=js"
import style0 from "./text-image-cta.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports